var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0022 18.4995C11.093 18.4995 7.11328 14.3582 7.11328 9.24975C7.11328 4.14125 11.093 0 16.0022 0C20.9114 0 24.891 4.14125 24.891 9.24975C24.891 14.3582 20.9114 18.4995 16.0022 18.4995ZM16.0013 14.8001C17.9067 14.8001 19.6674 13.7423 20.6201 12.0252C21.5728 10.3081 21.5728 8.19251 20.6201 6.47538C19.6674 4.75826 17.9067 3.70047 16.0013 3.70047C13.0558 3.70047 10.668 6.18521 10.668 9.2503C10.668 12.3154 13.0558 14.8001 16.0013 14.8001ZM30.2222 36.9999C31.2041 36.9999 32 36.1717 32 35.15V31.4501C32 26.3416 28.0203 22.2004 23.1111 22.2004H8.88889C3.97969 22.2004 0 26.3416 0 31.4501V35.15C0 36.1717 0.795938 36.9999 1.77778 36.9999C2.75962 36.9999 3.55556 36.1717 3.55556 35.15V31.4501C3.55556 28.385 5.94337 25.9003 8.88889 25.9003H23.1111C26.0566 25.9003 28.4444 28.385 28.4444 31.4501V35.15C28.4444 36.1717 29.2404 36.9999 30.2222 36.9999Z",
    fill: "#0552B5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1148,
    cy: 10.2884,
    rx: 7.32571,
    ry: 7.91391,
    fill: "#0552B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39503 24.6323H26.8605L30.2792 36.9978H1.95312L4.39503 24.6323Z",
    fill: "#0552B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/person-filled.cbc8451c79250c72e593dbaa80a54f53.svg";
export { ForwardRef as ReactComponent };